import { render, staticRenderFns } from "./SeparationAnxietyDoItYourselfCard.vue?vue&type=template&id=86262a18&scoped=true&"
import script from "./SeparationAnxietyDoItYourselfCard.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyDoItYourselfCard.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxietyDoItYourselfCard.vue?vue&type=style&index=0&id=86262a18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86262a18",
  null
  
)

export default component.exports